import React, {FC} from 'react';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {BaseGlassesProductItem} from 'components/baseProductItems/baseGlassesProductItem/baseGlassesProductItem';
import {RemoveItemButton} from 'components/baseProductItems/removeItemButton/removeItemButton';

import {NotificationBlock} from 'components/notificationBlock/notificationBlock';

import s from '../miniCartProductItem.scss';

export type PropsType = {
    item: QuoteItemV2;
};

/**
 * Product Item for checkout and cart pages
 */
export const MiniCartGlassesItem: FC<PropsType> = ({item}) => {
    const productHasNotification =
        item.product.stock?.isOutOfStock || item.product.stock?.isLowStock;

    return (
        <div className={s.cartItem}>
            <BaseGlassesProductItem
                removeComponent={
                    __BUILD_TYPE__ === 'desktop' && <RemoveItemButton item={item} isMiniCart />
                }
                item={item}
                nameComponent={<p className={s.name}>{item.windowName}</p>}
            >
                {item.options && Boolean(Object.keys(item.options).length) && (
                    <span className={s.text}>With customized lenses</span>
                )}
            </BaseGlassesProductItem>
            <NotificationBlock item={item} productHasNotification={productHasNotification} />
        </div>
    );
};
